import React from 'react'
import {CloseIcon} from 'components/icons'
import {CloseIconWrapper} from './styled'

const NotificationBarCloseIcon = ({type, onClick}) => (
  <CloseIconWrapper type={type}>
    <CloseIcon onClick={onClick} />
  </CloseIconWrapper>
)

export default NotificationBarCloseIcon
